import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { CampusActivityListResponseData } from "../../types/enum";

export const getData = async () => {
  const { data } =
    await api.get<CampusActivityListResponseData>(`/campus-activities`);

  return data;
};

export const useCampusActivities =
  (): QueryObserverBaseResult<CampusActivityListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.campusActivities(), () =>
      getData(),
    );

    return { data, ...props };
  };
